import React, { useState, useEffect } from 'react'
import btnStyles from '../styles/button.module.css'
import { useTranslation } from 'react-i18next'
import '../i18n'

const ActionButton = () => {
	const baseGooglePlayUrl =
		'https://play.google.com/store/apps/details?id=com.guppir.whispr'
	const appStoreLink =
		'https://apps.apple.com/app/apple-store/id1612446646?pt=122259015&ct=whispr_reply&mt=8'
	const [googlePlayUrl, setGooglePlayUrl] = useState(baseGooglePlayUrl)
	const { t } = useTranslation()
	const isIOS =
		typeof navigator !== 'undefined'
			? /(iPad|iPhone|iPod|iOS|OS)/i.test(navigator.userAgent)
			: false

	useEffect(() => {
		const queryString = window.location.search
		if (queryString) {
			setGooglePlayUrl(
				`${baseGooglePlayUrl}&referrer=${encodeURIComponent(
					queryString.substring(1)
				)}`
			)
		}
	}, [])

	const href = isIOS ? appStoreLink : googlePlayUrl

	return (
		<a href={href} className={`${btnStyles.btn} ${btnStyles['btn-animation']}`}>
			{t('makeYourOwnQuestionButton')}
		</a>
	)
}

export default ActionButton
